/**
 * 评论/留言/回复列表项字段归一化（点赞态、是否本人）。
 * - isMyLike：接口可能返回 isMyLike 或 isLike
 * - isBelongMe：接口返回是否为本人发送，用于展示删除等操作
 */
export function normalizeMessageFields(item) {
  if (!item || typeof item !== 'object') return item
  const liked = item.isMyLike ?? item.isLike
  return {
    ...item,
    isMyLike: Boolean(liked),
    isBelongMe: Boolean(item.isBelongMe),
  }
}

/**
 * 从新增消息/回复接口响应中解析 messageId（兼容 content / data / 顶层字段）
 * @param {object} responseData - axios response.data
 * @returns {string}
 */
export function resolveAddMessageId(responseData) {
  if (!responseData || typeof responseData !== 'object') return ''

  const candidates = []
  const content = responseData.content
  if (content && typeof content === 'object') {
    candidates.push(content.messageId, content.id)
  }
  const data = responseData.data
  if (data && typeof data === 'object') {
    candidates.push(data.messageId, data.id)
  } else if (data !== undefined && data !== null) {
    candidates.push(data)
  }
  candidates.push(responseData.messageId, responseData.id)

  for (const raw of candidates) {
    if (raw !== undefined && raw !== null && String(raw).trim() !== '') {
      return String(raw).trim()
    }
  }
  return ''
}

/**
 * 详情/阅读区评论行：接口可能只给 id 或只给 messageId，DOM 与定位统一用 messageId
 */
export function ensureCommentMessageId(item) {
  if (!item || typeof item !== 'object') return item
  const base = normalizeMessageFields(item)
  const raw = base.messageId ?? base.id
  const messageId =
    raw !== undefined && raw !== null && String(raw).trim() !== ''
      ? String(raw).trim()
      : base.messageId
  return { ...base, messageId }
}
